/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/device/current-time': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint32',
      },
    },
  },
};
